import { ScrollReveal } from "./ScrollReveal";
import { motion } from "framer-motion";

const partners = [
  { name: "Spartan Real Masters", img: "/image/spartan.png" },
  { name: "White Ocean Properties", img: "/image/white ocean.png" },
  { name: "Elite Realty Services LLP", img: "/image/elite.png" },
  { name: "RES Management", img: "/image/res.png" },
  { name: "Kunvarji Group", img: "/image/KunvarjiGroup.png" },
  { name: "City Estate Management", img: "/image/CityEstateManagement.png"  , large:true},
  { name: "Sikotar Properties", img: "/image/SikotarProperties.png" , large: true },
  { name: "Bavadiya Realty", img: "/image/BavadiyaRealty.png" },
  // { name: "Aditya Property", img: "/image/AdityaProperty.png" ,  large :  true  },
  { name: "Ideal Property Solution", img: "/image/IdealPropertySolution.png" },
  // { name: "Manisha Real Estate" },
  {name:"Manisha Real Estate", img:"/image/manish_real_esate.png"},
  { name: "M M Krupa Estate Consultants", img: "/image/MMKrupaEstatConsultants.png", large: true },
  { name: "Shelter4U", img: "/image/Shelter4U.png", large: true },
  { name: "Meldi Properties", img: "/image/MeldiProperties.png", large: true },
  { name: "Quality Space", img: "/image/QualitySpace.png", large: true },
  { name: "Rich Property Solutions", img: "/image/RichPropertySolutions.png", large: true },
  { name: "SIGNATURE REALTY", img: "/image/SIGNATUREREALTY.png"  },
  { name: "Devyog Property Solution", img: "/image/DevyogPropertySolution.png", large: true },
  { name: "Quality Living Property Solutions", img: "/image/QualityLivingPropertySolutions.png", large: true },
  { name: "Dream Space LLP", img: "/image/DreamSpaceLLP.png" },
  { name: "RE/MAX Realty Solutions", img: "/image/MAXRealtySolutions.png" },
  {name:"J.P. Consultancy", img:"/image/J.P.Consultancy.png" },
  {name:"Heaven Space", img:"/image/HEAVEN SPACE.png" , large: true},
  {name:"SP Property", img:"/image/SP Property.png"},
  {name:"Jagu Estate",img:'/image/JAGU_ESTATE.png'},
  {name:'Sun Property', img:'/image/Sun Property.png', large: true},
  {name:'TSG', img:'/image/TSG.png', large: true},
];

const TrustedBySection = () => (
  <section className="section-white py-12 sm:py-20 overflow-hidden border-b border-border/40">
    <div className="container mx-auto px-4 sm:px-6">
      <ScrollReveal>
        <div className="text-center mb-10">
          <p className="text-[10px] sm:text-xs font-bold uppercase tracking-[0.25em] text-primary/70 mb-3">
            Industry Leaders
          </p>
          <h2 className="text-xl sm:text-2xl font-bold text-foreground/90">
            Trusted by the best in Real Estate
          </h2>
        </div>
      </ScrollReveal>

      <div className="relative">
        <div className="flex animate-marquee gap-8 py-4" style={{ width: "max-content" }}>
          {[...partners, ...partners].map((partner, i) => (
            <motion.div
              key={i}
              whileHover={{ y: -5, borderColor: "rgba(124, 58, 237, 0.2)" }}
              className="flex-shrink-0 flex items-center justify-center px-6 py-4 bg-white border border-border/50 rounded-2xl shadow-sm hover:shadow-md transition-all duration-300 min-w-[280px] h-32 overflow-hidden"
            >
              {partner.img ? (
                <div className={`w-full h-full flex items-center justify-center p-2 ${partner.large ? 'scale-150' : 'scale-100'}`}>
                  <img 
                    src={partner.img} 
                    alt={partner.name}
                    className="max-h-full max-w-full object-contain"
                  />
                </div>
              ) : (
                <span className="text-lg sm:text-xl font-bold text-foreground/60 whitespace-nowrap px-4 text-center">
                  {partner.name}
                </span>
              )}
            </motion.div>
          ))}
        </div>
      </div>
    </div>
  </section>
);

export default TrustedBySection;
